module.exports = __webpack_public_path__ + "img/default-avatar.d8a851d0.jpg";